import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';

import { CapitalRequestInput } from '@scaleup/models';
import { Button } from '../../../ui';

export const AmountNeeded = ({
  capitalRequestInput,
  handleChange,
  setCurrentStep,
  isLoading,
}: {
  capitalRequestInput: CapitalRequestInput;
  setCurrentStep: Dispatch<
    SetStateAction<
      | 'REQUIREMENTS'
      | 'INTRODUCTION'
      | 'CAPITAL TYPES'
      | 'GROWTH PLAN'
      | 'FINANCIALS'
      | 'OWNERSHIP'
      | 'EBITDA'
      | 'AMOUNT NEEDED'
      | 'BREAKDOWN'
      | 'REVIEW'
      | 'CONFIRMATION'
    >
  >;
  handleChange: (key: string, value: string) => void;
  isLoading: boolean;
}) => {
  return (
    <div className="flex gap-8">
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-2">
          <span className="text-2xl font-bold">Total Amount Needed</span>
          <span className="text-base font-normal">
            Enter the amount you need for your business growth.
          </span>
        </div>
        <div className="flex items-center gap-2 bg-gray-100 rounded-2xl px-4 py-2">
          <Image
            src="/icons/currency.svg"
            alt="Prefix Icon"
            width={20}
            height={20}
          />
          <input
            type="text"
            className="w-full bg-gray-100 focus:bg-none focus:border-none"
            placeholder="Enter amount"
            value={capitalRequestInput.capitalNeed}
            onChange={(e) => handleChange('capitalNeed', e.target.value)}
          />
        </div>
        <div className="flex gap-3">
          <div>
            <Button
              text="Back"
              variant={isLoading ? 'disabled' : 'secondary'}
              onClick={() => setCurrentStep('EBITDA')}
            />
          </div>
          <div>
            <Button
              text="Continue"
              variant={isLoading ? 'disabled' : 'primary'}
              suffixIcon="/icons/arrow_right.svg"
              onClick={() => setCurrentStep('BREAKDOWN')}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-center">
        <Image
          src="/create_cr.png"
          alt="Supplier Request Image"
          priority
          width={512}
          height={584}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};
